export const SCREEN_OPTIONS = [
  { label: 'Bill Entry', value: 'bill-entry' },
  { label: 'WholeSale', value: 'wholesale' },
  { label: 'Wholesale Return', value: 'wholesale-return-billing' },
  { label: 'Wholesale Return History', value: 'wholesale-return-history' },
  { label: 'Online Order', value: 'order' },
  { label: 'Dunzo Catalogue', value: 'dunzo' },
  { label: 'Online Order', value: 'online-orders' },
  { label: 'Bill History', value: 'bill-history' },
  { label: 'Online Order History', value: 'order-history' },
  { label: 'Sales Return', value: 'sales-return' },
  { label: 'Sales Return History', value: 'sales-return-history' },
  { label: 'Purchase Entry', value: 'purchase-entry' },
  { label: 'Purchase Order', value: 'purchase-order' },
  { label: 'Purchase History', value: 'purchase-history' },
  { label: 'Purchase Return', value: 'purchase-return' },
  { label: 'Purchase Return History', value: 'purchase-return-history' },
  { label: 'Suppliers', value: 'suppliers' },
  { label: 'Cheque Payment', value: 'cheque-payment' },
  { label: 'Customers', value: 'customers' },
  { label: 'Doctors', value: 'doctors' },
  { label: 'Payments History', value: 'payments-history' },
  { label: 'Inventory', value: 'inventory' },
  { label: 'Med Wiki', value: 'medicine-wikipedia' },
  { label: 'Reports', value: 'report' },
  { label: 'Merge Duplicates', value: 'merge-duplicate' },
  { label: 'Item Mapping', value: 'item-mapping' },
  { label: 'GSTR Sales Report', value: 'gst-report-sales' },
  { label: 'GSTR Purchase Report', value: 'gst-report-purchase' },
  { label: 'GSTR-3B Report', value: 'gst-report-gstr3b' },
  { label: 'GSTR-2A Report', value: 'gst-report-gstr2a' },
  { label: 'GSTR-1 Report', value: 'gst-report-gstr1' },
  { label: 'Expiry report', value: 'expiry-report' },
  { label: 'Stock report', value: 'stock-report' },
  { label: 'Stock adjustment report', value: 'stock-adjustment-report' },
  { label: 'Non moving items report', value: 'non-moving-items-report' },
  { label: 'Schedule report', value: 'schedule-report' },
  { label: 'Item mapping report', value: 'item-mapping-report' },
  { label: 'Overbought report', value: 'overbought-report' },
  { label: 'Oversold report', value: 'oversold-report' },
  { label: 'Low stock report', value: 'low-stock-report' },
  { label: 'Itemwise sales margin report', value: 'itemwise-sales-margin-report' },
  { label: 'Batchwise sales report', value: 'batchwise-sales-report' },
  { label: 'Itemwise sales report', value: 'itemwise-sales-report' },
  { label: 'Batchwise purchase report', value: 'batchwise-purchase-report' },
  { label: 'New item report', value: 'new-item-report' },
  { label: 'Wanted note', value: 'wanted-note' },
  { label: 'Wanted Note History', value: 'wanted-note-history' },
  { label: 'Cash & Bank Book', value: 'cash-bank-book' },
  { label: 'Manage expenses', value: 'manage-expenses' },
  { label: 'Dashboard', value: 'dashboard' },
  { label: 'Analytics Dashboard', value: 'analytics-dashboard' },
  { label: 'View Payment', value: 'viewPayment' },
  { label: 'Store Profile', value: 'store-profile' },
  { label: 'Settings', value: 'settings' },
  { label: 'Stock Transfer', value: 'stock-transfer' },
  { label: 'Transfer Details', value: 'transfer-details' },
  { label: 'Branches', value: 'branches' },
  { label: 'Generated Report', value: 'generated-report' },
  { label: 'Pre Print Configuration', value: 'pre-printed-configuration' },
  { label: 'WMS', value: 'wms' },
  { label: 'Wholesale Bill History', value: 'wholesale/bill-history' },
  { label: 'Wholesale Retailers', value: 'wholesale/retailers' },
  { label: 'WMS Bill Entry', value: 'wholesale/bill-entry' },
  { label: 'GRN History', value: 'wms/grn-history' },
  { label: 'GRN Entry', value: 'wms/grn-entry' },
  { label: 'Picklist History', value: 'wms/picklist-history' },
  { label: 'Putaway History', value: 'wms/putaway-history' },
];
